import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, Observable } from 'rxjs';
// The file rather than the barrel: '../service' also exports the Firebase
// service, so importing it here drags the whole Firebase module graph into
// anything that loads this guard, tests included.
import { JWTService } from '../service/jwt.service';

/**
 * Logged in, or sent to the welcome screen. Nothing else.
 *
 * IT USED TO HAVE AN EXCEPTION, and the exception is what broke. Signing up with
 * an email address created no account: the password screen remembered the
 * credentials and sent the person to /onboarding, where the account was created
 * at the end. /onboarding sits behind this guard, so it needed a way to let a
 * person through who was not yet logged in -- first by reading a localStorage key
 * that held their password, then, once that key was removed, by asking the
 * application whether a sign-up was pending.
 *
 * Maude decided on 28 September 2026 that the account is created as soon as the
 * password is confirmed. Whoever reaches /onboarding is therefore logged in, the
 * exception has nothing left to admit, and the question it asked -- and the
 * PendingSignupGate that answered it -- are gone with it.
 */
export const AuthenticatedGuard: CanActivateFn = (route, state) => {
  const authService = inject(JWTService);
  const router = inject(Router);
  const isLoggedIn$: Observable<boolean> = authService.isLoggedIn();
  return isLoggedIn$.pipe(
    map((isLoggedIn) => {
      if (!isLoggedIn) {
        // Persist for post-login resume (UserSignedAction reads
        // sessionStorage). Query param alone is dropped by auth
        // child redirects and is never passed into sign-in actions.
        sessionStorage.setItem('returnUrl', state.url);
        return router.createUrlTree(['auth/first'], {
          queryParams: { returnUrl: state.url },
        });
      }
      return true;
    }),
  );
};
